import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { isNullOrDefined } from '@/utils';
export default {
  name: 'input-number',
  props: {
    modelValue: [String, Number],
    type: String,
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99999
    },
    precision: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;

    function inputHandle(value) {
      if (isNullOrDefined(value)) return;

      if (props.type === 'number') {
        if (isNaN(value)) return;
        value = Number(value);
        emits('update:modelValue', value);
      }
    }

    function changeHandle(value) {
      if (props.type === 'number') {
        if (value > props.max) {
          value = props.max;
        }

        value = Number(value).toFixed(props.precision);
        emits('update:modelValue', value);
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      return _openBlock(), _createBlock(_component_el_input, {
        modelValue: __props.modelValue,
        type: __props.type,
        min: __props.min,
        max: __props.max,
        onInput: inputHandle,
        onChange: changeHandle
      }, {
        append: _withCtx(() => [_renderSlot(_ctx.$slots, "append")]),
        _: 3
      }, 8, ["modelValue", "type", "min", "max"]);
    };
  }

};